import React, { useState } from "react";
import { connect, useSelector } from "react-redux";
import { useForm, useWatch } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { commonStyles } from "../AuthenticationLayout/authenticationLayoutCommonStyling.tailwind";
import forgotPasswordValidationSchema from "./forgotPassword.validation";
import Button from "../shared/Button/Button";
import { phoneNumberRegex } from "../../lib/constants/regexConstant.js";
import PhoneAndEmailField from "../shared/Input/PhoneAndEmailField/PhoneAndEmailField.jsx";
import { forgotPassword } from "../../redux/slices/authSlice.js";
import { VIA_EMAIL } from "../../lib/constants/globalConstant.js";
import OverlayLoader from "../shared/Loaders/OverlayLoader/OverlayLoader.jsx";
import { useNavigate } from "react-router-dom";
import routeConstant from "../../lib/constants/routeConstant.js";

const ForgotPasswordForm = ({ forgotPwd }) => {
  const navigate = useNavigate()
  const { isLoading: isSending } = useSelector(state => state.auth)
  
  // controller and state handled by react-router-dom
  const { control, setValue, handleSubmit, formState: { errors } } = useForm({
    resolver: yupResolver(forgotPasswordValidationSchema), // Use Yup resolver
  });

  // Watch the input value
  const inputValue = useWatch({ control, name: "value" }) || "";
  const [isPhoneInputVisible, setIsPhoneInputVisible] = useState(phoneNumberRegex.test(inputValue));

  // send mail to forgot-password
  const sendMail = async(formData) => {
    const data = isPhoneInputVisible
    ? {
        phoneNumber: `+${formData.value}`, // If phone, send it as `phoneNumber`
        viaEmail: VIA_EMAIL.PHONE_NUMBER,
      }
    : {
        email: formData.value, // If email, send it as `email`
        viaEmail: VIA_EMAIL.EMAIL, 
    };

    const response = await forgotPwd(data)
    if(forgotPassword.fulfilled.match(response)){
      navigate(routeConstant.LOGIN_PAGE)
    }
  }

  return (
    <div className={commonStyles.sub_container}>
      {isSending && <OverlayLoader />}
      <form className={commonStyles.form_wrpr} onSubmit={handleSubmit(sendMail)}>
        {/* Email or Phone Number Input componet handled by PhoneAndEmailField */}
          <PhoneAndEmailField
            name="value"
            control={control}
            setValue={setValue}
            inputValue={inputValue}
            isPhoneInputVisible={isPhoneInputVisible}
            setIsPhoneInputVisible={setIsPhoneInputVisible}
            error={!!errors.value}
            helperText={errors.value?.message}
          />
        
        {/* Login Button */}
        <Button variant="primary" type="submit" className={commonStyles.loginButton} disabled={isSending}>{isSending ? `Sending...` : `Reset Password`}</Button>
      </form>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => ({
  forgotPwd: (data) => dispatch(forgotPassword(data)),
});

export default connect(null, mapDispatchToProps)(ForgotPasswordForm)